<template>
  <v-card class="mb-7">
    <v-card-text class="pa-5">
      <div class="d-sm-flex align-center">
        <div class="ml-3">
          <h2 class="font-weight-regular title">Inscripciones</h2>
          <h6 class="body-2 mb-1 subtitle-2 font-weight-light">Datos de inscritos</h6>
        </div>

        <v-spacer></v-spacer>

        <v-btn color="secondary" class="mt-3 mt-sm-0" :loading="exportLoading" @click="exportarCsv">
          <v-icon left>mdi-download</v-icon>
          Exportar CSV / Excel
        </v-btn>

        <div class="ml-auto mt-4 mt-md-0">
          <div style="width: 150px">
            <v-btn :to="{ name: 'NewInscription' }" class="mx-4" color="primary">
              <v-icon>mdi-plus</v-icon>
              Agregar
            </v-btn>
          </div>
        </div>
      </div>

      <div class="d-flex align-center pa-3 flex-wrap">
        <v-select
          v-model="filters.seccion"
          label="Sección"
          class="mr-5"
          :items="secciones"
          item-text="nombre"
          item-value="id"
          outlined
          dense
          hide-details
          style="max-width: 210px"
          @change="filters.page = 1"
          clearable
        />

        <v-select
          v-model="filters.institucion"
          label="Institución"
          class="mr-5"
          :items="instituciones"
          item-text="nombre"
          item-value="id"
          outlined
          dense
          hide-details
          style="max-width: 210px"
          @change="filters.page = 1"
          clearable
        />

        <v-select
          v-model="filters.region"
          label="Región"
          class="mr-5"
          :items="regions"
          item-text="name"
          item-value="id"
          outlined
          dense
          hide-details
          style="max-width: 210px"
          @change="filters.page = 1"
          clearable
        />

        <v-select
          v-model="filters.estado"
          label="Estado"
          class="mr-5"
          :items="estados"
          item-text="text"
          item-value="value"
          outlined
          dense
          hide-details
          style="max-width: 210px"
          @change="filters.page = 1"
          clearable
        />

        <BaseDataRange
          style="max-width: 474px; margin: 0"
          @sendStartDate="sendStartDate"
          @sendEndDate="sendEndDate"
          @clearStartDate="filters.startDate = ''"
          @clearEndDate="filters.endDate = ''"
        />
        
        <div class="pa-0 pt-2" style="max-width: 420px;">
          <v-text-field
            v-model="searchLocal"
            prepend-inner-icon="mdi-magnify"
            dense
            outlined
            clearable
            hide-details
            label="Buscar Coincidencia"
            @input="onLocalSearchInput"
          />
        </div>


      </div>
      <!-- Fin Header -->

      <!-- Table -->
      <v-data-table
        :headers="headerArray"
        :items="extractItems"
        :page.sync="filters.page"
        :items-per-page="pageSize"
        :server-items-length="totalItems"
        :loading="loading"
        :options.sync="options"
        hide-default-footer
        @click:row="showInscription"
      >
      
        <template v-slot:item.estado="{ item }">
          <v-chip
            class="state px-3 flex-grow-1"
            :class="{
              'state__listo': item.estado === 'LISTO',
              'state__verificado': item.estado === 'VERIFICADO',
              'state__noprocede': item.estado === 'NO_PROCEDE',
              'state__recibido': item.estado === 'RECIBIDO'
            }"
          >
            {{ getStatus(item) }}
          </v-chip>
        </template>

        <template v-slot:item.nombre="{ item }">
          <div class="d-flex" style="cursor: pointer">
            <div class="my-auto">
              <h4 class="font-weight-medium text-no-wrap">{{ item.nombres }}</h4>
              <h6 class="font-weight-medium text-no-wrap">{{ item.apellidos }}</h6>

              <p
                class="font-weight-medium text-no-wrap ma-0 enrollment_date"
                v-if="item.fecha_matricula !== null"
              >
                Matriculado el {{ item.fecha_matricula | moment('DD/MM/YYYY [a las] HH:mm') }}
              </p>
            </div>
          </div>
        </template>

        <!-- Pagination -->
        <template v-slot:footer="slotProps">
          <div class="pagination d-flex ml-auto mr-0 mt-5">
            <v-btn icon @click="filters.page > 1 ? filters.page-- : ''" :disabled="filters.page === 1">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <p class="ma-auto">
              {{ slotProps.props.pagination.page }} de {{ totalPages }}
            </p>

            <v-btn icon @click="filters.page < totalPages ? filters.page++ : ''" :disabled="next === null">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
      <!-- Table -->
    </v-card-text>
  </v-card>
</template>

<script>
import NProgress from 'nprogress'
import { mapMutations, mapState } from 'vuex'
import BaseDataRange from '@/components/commonComponents/BaseDataRange.vue'

export default {
  name: 'TheInscriptionTable',
  components: { BaseDataRange },

  data: () => ({
    inscriptions: [],
    pageSize: 15,
    totalPages: 1,
    totalItems: 0,
    next: null,
    loading: false,
    timeout: null,
    exportLoading: false,
    searchLocal: '',
    filters: {
      startDate: '',
      endDate: '',
      page: 1,
      search: '',
      seccion: null,
      institucion: null,
      region: null,
      estado: null
    },

    options: {
      sortBy: [],
      sortDesc: []
    },

    headerArray: [
      { text: 'Nombre', value: 'nombre', sortable: true, align: 'start' },
      { text: 'Sección', value: 'seccion', sortable: true, align: 'start' },
      { text: 'Celular', value: 'celular', sortable: true, align: 'center' },
      { text: 'Universidad', value: 'universidad', sortable: true, align: 'end' },
      { text: 'Departamento', value: 'departamento', sortable: true, align: 'end' },
      { text: 'Estado', value: 'estado', sortable: true, align: 'end' }
    ],

    secciones: [],
    instituciones: [],
    regions: [],
    estados: [
      { text: 'Todos', value: '' },
      { text: 'Recibido', value: 'RECIBIDO' },
      { text: 'Listo', value: 'LISTO' },
      { text: 'Verificado', value: 'VERIFICADO' },
      { text: 'No procede', value: 'NO_PROCEDE' }
    ]
  }),

  watch: {
    searchGlobal () {
      this.filters.page = 1
      this.fetchData()
    },
    filters: {
      deep: true,
      handler () {
        this.fetchData()
      }
    },
    options: {
      deep: true,
      handler () {
        this.fetchInscriptions()
      }
    },
    seccionesStore (val) { if (Array.isArray(val) && val.length) this.secciones = val },
    regionsStore (val)   { if (Array.isArray(val) && val.length) this.regions = val },
    institucionesStore (val) { if (Array.isArray(val) && val.length) this.instituciones = val }
  },
  computed: {
    ...mapState({
      searchGlobal: (s) => s.searchGlobal,
      seccionesStore: (s) => s.secciones || [],
      regionsStore:   (s) => s.regions || s.regiones || [],
      institucionesStore: (s) => s.instituciones || []
    }),
    extractItems () {
      return this.inscriptions.map(item => {
        const regionObj = this.regions.find(r => r.id === item.region)
        return {
          id: item.id,
          nombres: item.nombres,
          apellidos: item.apellidos,
          seccion: item.seccion,
          celular: item.celular,
          universidad: item.institucion,
          departamento: regionObj ? regionObj.name : item.region,
          estado: item.estado,
          fecha_matricula: item.fecha_matricula,
          img: ''
        }
      })
    }
  },
  methods: {
    ...mapMutations(['SET_SEARCH']),

    async fetchData () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(async () => {
        await this.$router.replace({
          query: {
            fecha_inicio: this.filters.startDate,
            fecha_fin: this.filters.endDate,
            page: this.filters.page,
            search: this.searchGlobal,
            seccion: this.filters.seccion,
            institucion: this.filters.institucion,
            region: this.filters.region,
            estado: this.filters.estado
          }
        })
        await this.fetchInscriptions()
      }, 600)
    },

    mapOrderField (uiField) {
      switch (uiField) {
        case 'nombre':       return 'nombres'              // columna "Nombre"
        case 'seccion':      return 'seccion__nombre'      // columna "Sección"
        case 'universidad':  return 'institucion__nombre'  // columna "Universidad"
        case 'departamento': return 'region__name'         // columna "Departamento"
        default:             return uiField
    }
    },


    async fetchInscriptions () {
      this.loading = true

      const uiField = this.options.sortBy.length ? this.options.sortBy[0] : ''
      const serverField = uiField ? this.mapOrderField(uiField) : ''
      const ordering = serverField ? `${this.options.sortDesc[0] ? '-' : ''}${serverField}` : ''

      const params = new URLSearchParams({
        page_size: this.pageSize,
        page: this.filters.page,
        fecha_inicio: this.filters.startDate || '',
        fecha_fin: this.filters.endDate || '',
        seccion: this.filters.seccion || '',
        institucion: this.filters.institucion || '',
        region: this.filters.region || '',
        estado: this.filters.estado || '',
        search: this.searchGlobal || '',
        ordering
      })

      const url = `api/admin/matriculas/formularios/?${params}`

      const inscriptionsResponse = await this.$http.get(url)
      this.next = inscriptionsResponse.data.next
      this.inscriptions = inscriptionsResponse.data.results
      this.totalItems = inscriptionsResponse.data.count
      this.totalPages = Math.ceil(inscriptionsResponse.data.count / this.pageSize)
      this.loading = false
    },

    onLocalSearchInput () {
      this.SET_SEARCH(this.searchLocal)
    },

    // Exportación CSV con mismos filtros
    async exportarCsv () {
      try {
        this.exportLoading = true

        const uiField = this.options.sortBy.length ? this.options.sortBy[0] : ''
        const serverField = uiField ? this.mapOrderField(uiField) : ''
        const ordering = serverField ? `${this.options.sortDesc[0] ? '-' : ''}${serverField}` : ''

        const params = new URLSearchParams({
          fecha_inicio: this.filters.startDate || '',
          fecha_fin: this.filters.endDate || '',
          seccion: this.filters.seccion || '',
          institucion: this.filters.institucion || '',
          region: this.filters.region || '',
          estado: this.filters.estado || '',
          search: this.searchGlobal || '',
          ordering
        })

        const url = `api/admin/matriculas/formularios/export_csv/?${params}`
        // usa axios ya configurado para incluir auth/cookies
        const res = await this.$http.get(url, { responseType: 'blob' })

        const blob = new Blob([res.data], { type: res.headers['content-type'] || 'text/csv' })
        const cd = res.headers['content-disposition']
        const filename = this.filenameFromContentDisposition(cd) || 'formularios_detalle.csv'

        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = filename
        document.body.appendChild(link)
        link.click()
        link.remove()
        URL.revokeObjectURL(link.href)
      } catch (err) {
        console.error(err)
        await this.$root.$confirm({
          title: '¡Lo sentimos!',
          message: 'No se pudo exportar el CSV. Revisa tu sesión y permisos',
          acceptText: 'Aceptar'
        })
      } finally {
        this.exportLoading = false
      }
    },
    filenameFromContentDisposition (header) {
      if (!header) return null
      const match = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(header)
      return match && decodeURIComponent(match[1])
    },

    async fetchRegions () {
      const res = await this.$http.get('api/ciudades/region/', {
        params: { 'country__name': 'Peru' }
      })
      this.regions = res.data
    },

    async fetchSecciones () {
      const res = await this.$http.get('api/matriculas/secciones/')
      this.secciones = res.data
    },

    async fetchUniversidades () {
      const res = await this.$http.get('api/instituciones/')
      this.instituciones = res.data
    },

    sendStartDate (item) {
      this.filters.page = 1
      this.filters.startDate = item
    },

    sendEndDate (item) {
      this.filters.page = 1
      this.filters.endDate = item
    },

    getStatus (inscription) {
      if (inscription.estado === 'RECIBIDO') return 'Recibido'
      if (inscription.estado === 'LISTO') return 'Listo'
      if (inscription.estado === 'VERIFICADO') return 'Verificado'
      if (inscription.estado === 'NO_PROCEDE') return 'No procede'
      return '-'
    },

    showInscription (inscription) {
      this.$router.push({ name: 'UpdateInscription', params: { id: inscription.id } })
    },

    setInitialQueryParams () {
      this.filters = {
        startDate: this.$route.query.fecha_inicio || '',
        endDate: this.$route.query.fecha_fin || '',
        page: this.$route.query.page || 1,
        seccion: this.$route.query.seccion || null,
        institucion: this.$route.query.institucion || null,
        region: this.$route.query.region || null,
        estado: this.$route.query.estado || null
      }
    }
  },

  async mounted () {
    await NProgress.start()
    const preloadTasks = []
    if (this.seccionesStore?.length) this.secciones = this.seccionesStore
    else preloadTasks.push(this.fetchSecciones())

    if (this.regionsStore?.length) this.regions = this.regionsStore
    else preloadTasks.push(this.fetchRegions())

    if (this.institucionesStore?.length) this.instituciones = this.institucionesStore
    else preloadTasks.push(this.fetchUniversidades())

    await Promise.all(preloadTasks)

    if (this.$route.query.search) {
      await this.SET_SEARCH(this.$route.query.search)
    }
    this.searchLocal = this.searchGlobal || ''

    this.setInitialQueryParams()
    await this.fetchInscriptions()
    await NProgress.done()
  }
}
</script>

<style lang="scss" scoped>
.state {
  max-height: 23px;
  color: #fff;
  border-radius: 5px;
  &__recibido {
    background: #1e88e5 !important;
  }
  &__listo {
    background: #26c6da !important;
  }
  &__verificado {
    background: #4caf50 !important;
  }
  &__noprocede {
    background: #fc4b6c !important;
  }
}
.enrollment_date {
  color: #1e88e5;
  font-size: 12px;
}
</style>
